module.exports = __webpack_public_path__ + "img/sTriKfMnky_193x205.c7a610a8.png";